import React from "react";
import { createRoot } from "react-dom/client";
import PodStudio from "./PodStudio.jsx";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PodStudio />
  </React.StrictMode>
);
